import { createImmerStore } from '@/state/createImmerStore';
import type { CanvasState } from './canvas/types';
import { createCtx } from './canvas/ctx';
import { createTemplatesSlice } from './canvas/slices/templates';
import { createGraphSlice } from './canvas/slices/graph';
import { createHistorySlice } from './canvas/slices/history';
import { createUISlice } from './canvas/slices/ui';
import { createNodesSlice } from './canvas/slices/nodes';
import { createEdgesSlice } from './canvas/slices/edges';
import { createInferenceSlice } from './canvas/slices/inference';
import { createMappingSlice } from './canvas/slices/mapping';

export const useCanvasStore = createImmerStore<CanvasState>((set, get) => {
  const ctx = createCtx(set, get);
  (get as any).__ctx = ctx;

  return {
    graph: { id: null, nodes: [], edges: [], meta: {}, structureVersion: 0 },
    templates: null,
    ui: {
      selection: { nodes: new Set(), edges: new Set() },
      history: { past: [], future: [] },
      contextMenu: { open: false, x: 0, y: 0 },
      commandBar: { open: false, x: 0, y: 0, query: '', context: null },
      pendingConnect: null,
      mapper: { open: false, edgeId: null, view: 'liquid' },
      pendingCenterNodeId: null,
      isDraggingNodes: false,
    },
    ...createTemplatesSlice(set, get),
    ...createGraphSlice(set, get),
    ...createHistorySlice(set, get),
    ...createUISlice(set, get),
    ...createNodesSlice(set, get),
    ...createEdgesSlice(set, get),
    ...createInferenceSlice(set, get),
    ...createMappingSlice(set, get),
  };
});

export default useCanvasStore;
export type { CanvasState } from './canvas/types';
